import { render, staticRenderFns } from "./StudentCreateClass.vue?vue&type=template&id=3bbe8811&"
import script from "./StudentCreateClass.vue?vue&type=script&lang=js&"
export * from "./StudentCreateClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports